import { createStyles, makeUiStyles, Theme } from '../styles/styles';
import { StylesIndexInjections } from 'common-react';

export default makeUiStyles((theme: Theme) => createStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    gap: 4,
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
    },
  },
}), { name: 'SfdrCategoryFundItem', index: StylesIndexInjections.UI_MOLECULES });
